module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'form',
    ],

    config: {
        isFullyVertical: false,
        isFullyHorizontal: true,
        resourceConnected: false,
    },

    methods: {
        showInsert(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
            this.closest('templates_core_controller_controller', controller => {
                controller.showInsert(buttonContext, buttonMode)
            })
        }
    }
}